import React from "react";
import {Alert, Card} from "flowbite-react";
import {HiInformationCircle} from "react-icons/hi";
import Code from "../Code";

export default function DocSection({ title, description, examples, alert }) {
    return (
        <div className="text-gray-500 sm:text-lg dark:text-gray-300">
            <h3 className="mb-4 text-2xl tracking-tight font-bold text-gray-900 dark:text-white">
                {title}
            </h3>
            <div className="mb-4 font-light">
                <div className="mb-4">{description}</div>
                {examples.map((example, index) => (
                    <Card key={index} className="max-w-screen-lg mt-4">
                        <h4 className="text-lg font-semibold">Example {index + 1}</h4>
                        {<Code code={example} language="html"></Code>}
                    </Card>
                ))}
                {alert && (
                    <Alert color={alert.color} icon={HiInformationCircle} className="mt-4">
                        {alert.message}
                    </Alert>
                )}
            </div>
        </div>
    );
}
